import { Component, Input } from '@angular/core';
import { addIcons } from 'ionicons';
import { helpCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-help-hint',
  templateUrl: './help-hint.component.html',
  styleUrls: ['./help-hint.component.scss']
})
export class HelpHintComponent {
  @Input() tooltipText =
    'ECO uses fewer tokens; FULL runs more searches.';
  @Input() link = '/app/tokens';
  @Input() linkLabel = '¿Qué son los tokens?';

  constructor() {
    addIcons({ helpCircleOutline });
  }
}
